(function(){
  'use strict';
  var R = window.romi || {routes:{root:'/',cart:'/cart',add:'/cart/add',change:'/cart/change'},t:{}};
  var T = R.t;
  var $ = function(s,el){return (el||document).querySelector(s)};
  var $$ = function(s,el){return Array.prototype.slice.call((el||document).querySelectorAll(s))};
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var esc = function(s){return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]})};
  var fmt = function(cents){
    try{return new Intl.NumberFormat(R.locale==='fr'?'fr-CA':'en-CA',{style:'currency',currency:R.currency||'CAD'}).format(cents/100)}
    catch(e){return '$'+(cents/100).toFixed(2)}
  };
  var url = function(path){ var root=R.routes.root; if(root.slice(-1)!=='/')root+='/'; return root+path; };

  /* ---------- mobile menu ---------- */
  var menuBtn=$('#menuBtn'), mnav=$('#mnav');
  if(menuBtn&&mnav){
    menuBtn.addEventListener('click',function(){var open=mnav.hidden;mnav.hidden=!open;menuBtn.setAttribute('aria-expanded',String(open))});
    $$('a',mnav).forEach(function(a){a.addEventListener('click',function(){mnav.hidden=true;menuBtn.setAttribute('aria-expanded','false')})});
  }

  /* ---------- toast ---------- */
  var toastT;
  function toast(msg){var t=$('#toast');if(!t)return;$('#toastMsg').textContent=msg;t.classList.add('show');clearTimeout(toastT);toastT=setTimeout(function(){t.classList.remove('show')},3500)}

  /* ---------- cart drawer (Shopify AJAX cart) ---------- */
  var drawer=$('#drawer'), scrim=$('#scrim'), lastFocus=null, cartState=null;
  function setCount(n){var c=$('#cartCount');if(!c)return;c.textContent=n;c.classList.remove('bump');void c.offsetWidth;c.classList.add('bump');var b=$('#cartBtn');if(b)b.setAttribute('aria-label',(T.cartLabel||'Cart')+' ('+n+')')}
  function getCart(){return fetch(url('cart.js'),{headers:{'Accept':'application/json'}}).then(function(r){if(!r.ok)throw new Error(r.status);return r.json()})}
  function render(cart,err){
    cartState=cart;var body=$('#drBody'),foot=$('#drFoot');if(!body)return;
    setCount(cart.item_count);
    if(!cart.item_count){
      body.innerHTML='<div class="empty"><h3>'+esc(T.emptyTitle)+'</h3><p class="note">'+esc(T.emptyBody)+'</p><a class="btn small" href="'+esc(url('collections/all'))+'">'+esc(T.shop)+'</a></div>';
      foot.hidden=true;foot.innerHTML='';return;
    }
    body.innerHTML=cart.items.map(function(it,i){
      var disc=(it.line_level_discount_allocations||[]).map(function(d){return '<div class="disc">'+esc(d.discount_application.title)+' (−'+fmt(d.amount)+')</div>'}).join('');
      var variant=(it.product_has_only_default_variant||!it.variant_title)?'':'<div class="vr">'+esc(it.variant_title)+'</div>';
      var img=it.image?'<img src="'+esc(it.image+(it.image.indexOf('?')>-1?'&':'?')+'width=160')+'" alt="" width="72" height="72">':'<span></span>';
      var old=it.original_line_price>it.final_line_price?'<s>'+fmt(it.original_line_price)+'</s>':'';
      return '<div class="line">'+img+'<div><a class="nm" href="'+esc(it.url)+'" style="text-decoration:none">'+esc(it.product_title)+'</a>'+variant+disc+
        '<div style="display:flex;align-items:center"><div class="qty"><button type="button" data-key="'+esc(it.key)+'" data-q="'+(it.quantity-1)+'" aria-label="'+esc(T.less)+'">−</button><output>'+it.quantity+'</output><button type="button" data-key="'+esc(it.key)+'" data-q="'+(it.quantity+1)+'" aria-label="'+esc(T.more)+'">+</button></div>'+
        '<button type="button" class="rm" data-key="'+esc(it.key)+'" data-q="0">'+esc(T.remove)+'</button></div></div><span class="price">'+old+fmt(it.final_line_price)+'</span></div>';
    }).join('');
    var cartDisc=(cart.cart_level_discount_applications||[]).map(function(d){return '<div class="subtotal disc"><span>'+esc(d.title)+'</span><span>−'+fmt(d.total_allocated_amount)+'</span></div>'}).join('');
    foot.hidden=false;
    foot.innerHTML=(err?'<p class="err" role="alert">'+esc(T.error)+'</p>':'')+cartDisc+'<div class="subtotal"><span>'+esc(T.subtotal)+'</span><span class="price">'+fmt(cart.total_price)+'</span></div><p class="note">'+esc(T.taxNote)+'</p><button class="btn" type="submit" name="checkout">'+esc(T.checkout)+'</button>';
  }
  function openCart(){
    if(!drawer)return;lastFocus=document.activeElement;var t=$('#toast');if(t)t.classList.remove('show');
    drawer.classList.add('open');drawer.setAttribute('aria-hidden','false');scrim.classList.add('open');$('#drClose').focus();
    getCart().then(function(c){render(c)}).catch(function(){if(cartState)render(cartState,true)});
  }
  function closeCart(){if(!drawer)return;drawer.classList.remove('open');drawer.setAttribute('aria-hidden','true');scrim.classList.remove('open');if(lastFocus&&lastFocus.focus)lastFocus.focus()}
  window.romiOpenCart=openCart;
  var cartBtn=$('#cartBtn');
  if(cartBtn&&drawer&&document.body.className.indexOf('tpl-cart')===-1){cartBtn.addEventListener('click',function(e){e.preventDefault();openCart()})}
  if(drawer){
    $('#drClose').addEventListener('click',closeCart);scrim.addEventListener('click',closeCart);
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&drawer.classList.contains('open'))closeCart()});
    drawer.addEventListener('click',function(e){
      var b=e.target.closest('[data-key]');if(!b)return;
      b.disabled=true;
      fetch(url('cart/change.js'),{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:b.dataset.key,quantity:Math.max(0,parseInt(b.dataset.q,10))})})
        .then(function(r){if(!r.ok)throw new Error(r.status);return r.json()}).then(function(c){render(c)})
        .catch(function(){getCart().then(function(c){render(c,true)})});
    });
  }
  var tv=$('#toastView');if(tv)tv.addEventListener('click',openCart);

  function addItems(items){
    return fetch(url('cart/add.js'),{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})})
      .then(function(r){return r.json().then(function(j){if(!r.ok)throw new Error(j.description||j.message||'error');return j})})
      .then(function(){return getCart()}).then(function(c){render(c);toast(T.added);return c});
  }

  /* ---------- product page ---------- */
  var pj=$('#productJson');
  if(pj){
    var product=JSON.parse(pj.textContent), media=JSON.parse(($('#variantMedia')||{}).textContent||'{}');
    var form=$('#productForm'), vid=$('#variantId'), price=$('#price'), addBtn=$('#addBtn'), err=$('#addErr'), qv=$('#qv');
    var selected=[];
    $$('[data-option]').forEach(function(g){var on=$('[aria-checked="true"]',g);selected[+g.dataset.option]=on?on.dataset.value:null});
    var findVariant=function(){return product.variants.find(function(v){return v.options.every(function(o,i){return selected[i]==null||o===selected[i]})})};
    var current=product.variants.find(function(v){return String(v.id)===vid.value})||product.variants[0];
    function setMain(src,id){var m=$('#mainImg');if(!m||!src)return;m.removeAttribute('srcset');m.src=src;$$('#thumbs button').forEach(function(b){b.setAttribute('aria-current',String(b.dataset.media===String(id)))})}
    function markAvailability(){
      $$('[data-option]').forEach(function(g){var idx=+g.dataset.option;$$('.swatch',g).forEach(function(b){
        var ok=product.variants.some(function(v){return v.available&&v.options[idx]===b.dataset.value&&v.options.every(function(o,i){return i===idx||selected[i]==null||o===selected[i]})});
        b.classList.toggle('na',!ok);});});
    }
    function update(){
      var v=findVariant();current=v;
      if(!v){addBtn.disabled=true;addBtn.textContent=T.unavailable;return}
      vid.value=v.id;
      price.innerHTML=(v.compare_at_price>v.price?'<s>'+fmt(v.compare_at_price)+'</s>':'')+fmt(v.price);
      addBtn.disabled=!v.available;addBtn.textContent=v.available?T.add:T.soldOut;
      var sb=$('#sbName');if(sb)sb.textContent=product.title+(v.title&&product.variants.length>1?' · '+v.title:'')+' · '+fmt(v.price);
      var vm=media[v.id];if(vm)setMain(vm.src,vm.id);
      $$('[data-optval]').forEach(function(s){s.textContent=selected[+s.dataset.optval]||''});
      try{var u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState(null,'',u)}catch(e){}
      markAvailability();
    }
    $$('[data-option]').forEach(function(g){g.addEventListener('click',function(e){var b=e.target.closest('.swatch');if(!b)return;
      $$('.swatch',g).forEach(function(x){x.setAttribute('aria-checked',String(x===b))});selected[+g.dataset.option]=b.dataset.value;update()})});
    $$('#thumbs button').forEach(function(b){b.addEventListener('click',function(){setMain(b.dataset.src,b.dataset.media)})});
    $('#qm').addEventListener('click',function(){qv.value=Math.max(1,(parseInt(qv.value,10)||1)-1)});
    $('#qp').addEventListener('click',function(){qv.value=Math.min(20,(parseInt(qv.value,10)||1)+1)});
    markAvailability();
    function doAdd(){
      if(!current||!current.available)return;
      err.hidden=true;addBtn.disabled=true;
      addItems([{id:current.id,quantity:Math.max(1,parseInt(qv.value,10)||1)}]).then(function(){
        addBtn.textContent=T.addedBtn;setTimeout(function(){addBtn.disabled=false;addBtn.textContent=T.add},1400);
      }).catch(function(e){err.textContent=e.message||T.error;err.hidden=false;addBtn.disabled=false;addBtn.textContent=T.add});
    }
    form.addEventListener('submit',function(e){e.preventDefault();doAdd()});
    var sbAdd=$('#sbAdd');if(sbAdd)sbAdd.addEventListener('click',doAdd);
    var sticky=$('#stickyBuy');
    if(sticky&&'IntersectionObserver' in window){
      new IntersectionObserver(function(en){var s=!en[0].isIntersecting;sticky.classList.toggle('show',s);sticky.setAttribute('aria-hidden',String(!s));sbAdd.tabIndex=s?0:-1}).observe(addBtn);
    }
  }

  /* ---------- starter pair ---------- */
  var bundle=$('#bundle');
  if(bundle){
    $$('.swatches[data-img]',bundle).forEach(function(g){g.addEventListener('click',function(e){var b=e.target.closest('.swatch');if(!b)return;
      $$('.swatch',g).forEach(function(x){x.setAttribute('aria-checked',String(x===b))});var img=document.getElementById(g.dataset.img);if(img&&b.dataset.src)img.src=b.dataset.src})});
    $('#addBundle').addEventListener('click',function(){
      var btn=this;var ids=$$('.swatches[data-img]',bundle).map(function(g){var on=$('[aria-checked="true"]',g);return on&&on.dataset.variant});
      if(ids.some(function(x){return !x}))return;
      btn.disabled=true;
      addItems(ids.map(function(id){return {id:+id,quantity:1}})).then(function(){btn.disabled=false;openCart()})
        .catch(function(){btn.disabled=false;toast(T.error)});
    });
  }

  /* ---------- in-page anchors on home ---------- */
  document.addEventListener('click',function(e){var a=e.target.closest('a[href*="#"]');if(!a)return;var h=a.getAttribute('href');var id=h.split('#')[1];
    var el=id&&document.getElementById(id);if(el&&a.pathname===location.pathname){e.preventDefault();el.scrollIntoView({behavior:reduce.matches?'auto':'smooth'});if(mnav)mnav.hidden=true;history.replaceState(null,'','#'+id)}});
})();
